module.exports = __webpack_public_path__ + "img/7.657a7ead.jpg";